// Scraped and modified from https://api.twitch.tv/v5/bits/actions

const BASE_URL = 'https://d3aqoihi2n8ty8.cloudfront.net/actions/cheer'

module.exports = Object.freeze([
    {
        min_bits: 100,
        id: '1',
        color: '#979797',
        images: {
            animated: {
                1: `${BASE_URL}/dark/animated/1/1.gif`,
                2: `${BASE_URL}/dark/animated/1/2.gif`,
                3: `${BASE_URL}/dark/animated/1/3.gif`,
                1.5: `${BASE_URL}/dark/animated/1/1.5.gif`
            },
            static: {
                1: `${BASE_URL}/dark/static/1/1.png`,
                2: `${BASE_URL}/dark/static/1/2.png`,
                3: `${BASE_URL}/dark/static/1/3.png`,
                1.5: `${BASE_URL}/dark/static/1/1.5.png`
            }
        },
    },
    {
        min_bits: 500,
        id: '100',
        color: '#9c3ee8',
        images: {
            animated: {
                1: `${BASE_URL}/dark/animated/100/1.gif`,
                2: `${BASE_URL}/dark/animated/100/2.gif`,
                3: `${BASE_URL}/dark/animated/100/3.gif`,
                1.5: `${BASE_URL}/dark/animated/100/1.5.gif`
            },
            static: {
                1: `${BASE_URL}/dark/static/100/1.png`,
                2: `${BASE_URL}/dark/static/100/2.png`,
                3: `${BASE_URL}/dark/static/100/3.png`,
                1.5: `${BASE_URL}/dark/static/100/1.5.png`
            }
        },
    },
    {
        min_bits: 1000,
        id: '1000',
        color: '#1db2a5',
        images: {
            animated: {
                1: `${BASE_URL}/dark/animated/1000/1.gif`,
                2: `${BASE_URL}/dark/animated/1000/2.gif`,
                3: `${BASE_URL}/dark/animated/1000/3.gif`,
                1.5: `${BASE_URL}/dark/animated/1000/1.5.gif`
            },
            static: {
                1: `${BASE_URL}/dark/static/1000/1.png`,
                2: `${BASE_URL}/dark/static/1000/2.png`,
                3: `${BASE_URL}/dark/static/1000/3.png`,
                1.5: `${BASE_URL}/dark/static/1000/1.5.png`
            }
        },
    },
    {
        min_bits: 5000,
        id: '5000',
        color: '#0099fe',
        images: {
            animated: {
                1: `${BASE_URL}/dark/animated/5000/1.gif`,
                2: `${BASE_URL}/dark/animated/5000/2.gif`,
                3: `${BASE_URL}/dark/animated/5000/3.gif`,
                1.5: `${BASE_URL}/dark/animated/5000/1.5.gif`
            },
            static: {
                1: `${BASE_URL}/dark/static/5000/1.png`,
                2: `${BASE_URL}/dark/static/5000/2.png`,
                3: `${BASE_URL}/dark/static/5000/3.png`,
                1.5: `${BASE_URL}/dark/static/5000/1.5.png`
            }
        },
    },
    {
        min_bits: 10000,
        id: '10000',
        color: '#f43021',
        images: {
            animated: {
                1: `${BASE_URL}/dark/animated/10000/1.gif`,
                2: `${BASE_URL}/dark/animated/10000/2.gif`,
                3: `${BASE_URL}/dark/animated/10000/3.gif`,
                1.5: `${BASE_URL}/dark/animated/10000/1.5.gif`
            },
            static: {
                1: `${BASE_URL}/dark/static/10000/1.png`,
                2: `${BASE_URL}/dark/static/10000/2.png`,
                3: `${BASE_URL}/dark/static/10000/3.png`,
                1.5: `${BASE_URL}/dark/static/10000/1.5.png`
            }
        },
    }
])
